import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import ProductCarousel from '../../components/ProductCarousel/ProductCarousel';
import {
  PromoWrapper,
  PromoTitle,
	ViewAll,
} from '../Products/Products.style';
import t from '../../i18n/translate';

/**
 * PromoProducts Component
 * Displays promotional products using the reusable ProductCarousel
 */
const PromoProducts = ({deviceType, props}) => {

	// Memoize products to render
	const productsToRender = useMemo(() => {
		if (props.FilteredNameProducts === false && props.promoproducts) {
			return props.promoproducts;
    }
		return [];
	}, [props.FilteredNameProducts, props.promoproducts]);

	// Header component with title and "View All" link
	const HeaderComponent = (
		<PromoWrapper>
			<PromoTitle>{t('home_promotions_label')}</PromoTitle>
			<ViewAll>
				<a
					href="/best-deals/promotions"
					target="_blank"
					rel="noopener noreferrer"
					style={{textDecoration: 'none', color: 'inherit'}}
				>
					{t('home_view_all_label')}
				</a>
			</ViewAll>
		</PromoWrapper>
	);

	return (
		<ProductCarousel
			products={productsToRender}
			loading={props.promoloading}
			deviceType={deviceType}
			cartType={props.cartType}
			HeaderComponent={HeaderComponent}
		/>
  );
};

PromoProducts.propTypes = {
	deviceType: PropTypes.string,
	props: PropTypes.shape({
		promoproducts: PropTypes.array,
		promoloading: PropTypes.bool,
		FilteredNameProducts: PropTypes.bool,
		cartType: PropTypes.string,
	}).isRequired,
};

PromoProducts.defaultProps = {
	deviceType: 'desktop',
};

export default React.memo(PromoProducts);
